import api from './api/client';
import logger from '../utils/logger';

export const AgentMemoryService = {
  async getProfiles({ contractorId = 'default', jobsiteId = 'default', userId = 'default' }) {
    try {
      const params = new URLSearchParams({ contractorId, jobsiteId, userId });
      const url = `/api/agent/profile?${params.toString()}`;
      return await api.get(url);
    } catch (error) {
      logger.error('[AgentMemoryService] Failed to get profiles', { error: error.message });
      // Return empty profiles on error (including CORS/network errors)
      return { contractor: {}, jobsite: {}, user: {} };
    }
  },

  async updateProfile(scope, id, data) {
    try {
      return await api.post('/api/agent/profile/update', { scope, id, data });
    } catch (error) {
      logger.error('[AgentMemoryService] Failed to update profile', { error: error.message });
      return { success: false, error: error.message };
    }
  },

  async recordEvent(identity, event) {
    try {
      return await api.post('/api/agent/memory/event', { identity, event });
    } catch (error) {
      logger.error('[AgentMemoryService] Failed to record event', { error: error.message });
      // Silently fail - event recording is non-critical
      return { recorded: 0, results: [] };
    }
  },

  async getAutonomy({ contractorId = 'default', userId = 'default' }) {
    try {
      const params = new URLSearchParams({ contractorId, userId });
      const url = `/api/agent/autonomy?${params.toString()}`;
      return await api.get(url);
    } catch (error) {
      logger.error('[AgentMemoryService] Failed to get autonomy settings', { error: error.message });
      // Return default autonomy settings on error
      return { 
        level: 'supervised', 
        autoExecute: false, 
        notifyOnAction: true,
        riskThreshold: 'medium'
      };
    }
  },

  async setAutonomy(identity, settings) {
    try {
      return await api.post('/api/agent/autonomy', { identity, settings });
    } catch (error) {
      logger.error('[AgentMemoryService] Failed to set autonomy', { error: error.message });
      return { success: false, error: error.message };
    }
  },

  async getSuggestions(identity, dashboardContext) {
    try {
      return await api.post('/api/agent/suggestions', { identity, dashboardContext });
    } catch (error) {
      logger.error('[AgentMemoryService] Failed to get suggestions', { error: error.message });
      // Return empty suggestions on error
      return { suggestions: [] };
    }
  },
};

export default AgentMemoryService;
